import { render, staticRenderFns } from "./UberEats.vue?vue&type=template&id=33d78616&scoped=true"
import script from "./UberEats.vue?vue&type=script&lang=js"
export * from "./UberEats.vue?vue&type=script&lang=js"
import style0 from "./UberEats.vue?vue&type=style&index=0&id=33d78616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d78616",
  null
  
)

export default component.exports